import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { LatestCaseStudy } from '../homePageDesign23/LatestCaseStudy';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { BuildingExpertise } from './BuildingExpertise/BuildingExpertise';
import { StyledHorizontalDivider } from './BuildingExpertise/styles';
import { DeliveryProcess } from './DeliveryProcess/DeliveryProcess';
import { OurClients } from './OurClients';
import { OurServices } from './OurServices/OurServices';
import { servicesContactFormId } from './Services.consts';
import { servicesSeo } from './Services.seo';
import type { ServicesProps } from './Services.types';

export const Services = ({ blogPosts, caseStudies }: ServicesProps) => {
  const latestCaseStudy = caseStudies[0];

  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...servicesSeo} />
      <BuildingExpertise />
      <OurServices />
      <StyledHorizontalDivider />
      <DeliveryProcess />
      <LatestCaseStudy latestCaseStudy={latestCaseStudy} />
      <OurClients />
      <Contact id={servicesContactFormId} />
    </Layout>
  );
};
